<div class="modal-header" style="border-bottom: none;padding-top: 5px !important;padding: 0px;">
    <div class="col-md-12 col-12 col-xs-12">
        <div class="row" style=" padding-bottom: 0px;">
            <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                <h4 class="modal-title"><span>Select Period</span></h4>
            </div>
            <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                <i class="closeMdl zmdi zmdi-close" (click)="CloseModel()"></i>                       
            </div>
        </div>              
    <!-- <label>From : </label> -->
    <input matInput readonly [matDatepicker]="picker2" (click)="picker2.open()" [(ngModel)]="fromDate" 
        style="cursor: pointer; font-size: 14px; border-bottom-width: 1px; margin-left: 8px; border-top: 0px; border-left: 0px; padding: 0px; border-right: 0px;width: 65px;">
    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
    <mat-datepicker #picker2 color="primary"></mat-datepicker>

    <label style="font-size: 14px;">to :</label>

    <input matInput readonly [matDatepicker]="picker3" (click)="picker3.open()" [(ngModel)]="toDate" 
        style="cursor: pointer; font-size: 14px; border-bottom-width: 1px; margin-left: 8px; border-top: 0px; border-left: 0px; padding: 0px; border-right: 0px;width: 65px;">
    <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle> 
    <mat-datepicker #picker3 color="primary"></mat-datepicker>

   <span (click)="serach()" class="btn btn-orange" style="margin-top: 10px;margin-bottom: 15px; padding: 0px;line-height: 30px !important;
    padding: 5px 6px;font-size: 13px !important;color:#fff; border: 1px solid #e88421;  background:#e88421;border-radius: 25px;padding: 0px 15px;">
    <span><i  aria-hidden="true" class="zmdi zmdi-search" style="font-size: 16px;position: relative;top: 1px;"></i>
      </span>
        <span style="margin-left: 10px;">Search</span>
     </span>
    </div>
</div>